import script from "./ControleMensal.vue?vue&type=script&setup=true&lang=js"
export * from "./ControleMensal.vue?vue&type=script&setup=true&lang=js"

import "./ControleMensal.vue?vue&type=style&index=0&id=a9331422&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9331422"]])

export default __exports__